// extracted by mini-css-extract-plugin
export default {"button":"AddToBasket__button--BVOSo","active":"AddToBasket__active--GxX70"};